// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"144":"26e8bc92","253":"3c24e869"}[chunkId] + ".chunk.css";
};